// useCapacitorBackHandler.js

import { useEffect } from 'react';
import { setCustomNativeBackHandler, clearCustomNativeBackHandler} from './androidbackHandler'

/**
 * Hook for child components to temporarily take over the native back button.
 * @param {function} backAction The function to execute on native back press (e.g., handleBack).
 */
export const useCapacitorBackHandler = (backAction) => {
    useEffect(() => {
        // 1. On mount, register the component's back logic.
        setCustomNativeBackHandler(backAction);

        // 2. On unmount, clear the custom logic so the main hook takes over again.
        return () => {
            clearCustomNativeBackHandler();
        };
    }, [backAction]);
};